export enum ProjectDocFlowType {
    Electronic = 0,
    Paper
}